/*
WARNING. DO NOT EDIT THIS FILE. THIS FILE IS
GENERATED BY package.json. INSTEAD, MODIFY THE
APPROPRIATE FILE IN /src/config
*/

// @flow
export default {
  api_root: "https://api.imagus.com.au",
  homepage: "http://apps.imagus.com.au",
  facedb_root: "https://api.imagus.com.au/newapi",
  login_name: "imagus",
  secret_boolean: false // MAKE SURE TO SET FALSE IN PRODUCTION
};
